import React, {Component} from 'react';
import axios from 'axios';
import auth0Client from '../Auth';
import {withRouter} from 'react-router-dom';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import {ToastContainer, ToastStore} from 'react-toasts';
import {SERVER_URL}  from '../Constants';




class LMSTraining extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
        showAlert:false,
        disabled: false,
       
      };
    }
    
      // Login
    loginLMS=async()=>{
            await axios.post(`${SERVER_URL}/LMS/lmslogin`, {
           
                
            }, {
                headers: {  'Authorization': `Bearer ${auth0Client.getIdToken()}`,
                            'venueId' : auth0Client.getActiveVenuedId()
                        }
            })
                .then((res)=>{
                    // Open new widow with the login_key
                    window.open(res.data.login_key);
                    //console.log(res)
                    this.setState({
                        showAlert:false,
                        disabled: false,
                        showSuccess: true,

                    });
                    
    
            })
            .catch ((e)=>{
                console.log(e);
                this.setState({
                    showAlert:true,
                    disabled: false,
                    error:e,

                })
                console.log(e.message)
                // show error message if available
                ToastStore.error(e.message);
            })



  }
    renderToast=()=>{
        return <div>
            
            <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
        </div>
    }
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                   {this.renderToast()}
                <h2>BOUNTE Learning Management Training.</h2>

                <br/>
               

                <h6> Your account should be setup to access the new online Learning Manamagent System training module. <br/>  Contact your admin to gain access.</h6>
                
                <div className="row">
                    <div className="col-6">
                      <button
                         
                          className="btn btn-success"
                          onClick={() => {this.loginLMS()}}>
                          Log Into The Training System
                        </button>
                    </div>
                    
                </div>


                <br/>

                 
                
            </div>
        )
       


    }

}
export default withRouter(LMSTraining);
